module.exports = function (fox) {
	'use strict';

	require('./throughNotifications.js')(fox);
	require('fox-dynamic-injection!fox-template-loader!./templates.tpl')(fox);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/through-notifications/index.js
// module id = 207
// module chunks = 2